// ** Icons Import
import { Home, Circle } from "react-feather";

export default [
  {
    id: "dashboards",
    title: "Dashboards",
    icon: <Home size={20} />,
    children: [
      {
        id: "analyticsDash",
        title: "Overview",
        icon: <Circle size={12} />,
        navLink: "/dashboard/analytics",
        // Dashboard is always visible for every logged-in user
      },
    ],
  },
];
